import { HiExclamation } from 'react-icons/hi'

import { Alert, Box, Collapse, Icon } from '@chakra-ui/react'

interface RequiresAuthenticationAlertIProps {
  shouldRequireAuthentication: boolean
}

export const NoCameraAuthenticationAlert = ({
  shouldRequireAuthentication,
}: RequiresAuthenticationAlertIProps) => {
  return (
    <Collapse animateOpacity in={!shouldRequireAuthentication}>
      <Box fontSize='16px' mb='3'>
        <Alert
          borderRadius='10px'
          color='#923109'
          fontSize='13px'
          mb={4}
          status='warning'
        >
          <Icon as={HiExclamation} boxSize='20px' mr='10px' />
          <Box fontSize='sm' fontWeight='medium'>
            You're using an unauthenticated camera. Ensure its connected to a
            secure private network.
          </Box>
        </Alert>
      </Box>
    </Collapse>
  )
}
